import { Box, LinearProgress, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { FREE_CREDIT_BYTES } from '~/common/constants/temporary-contsants'

const getProgressColor = (pct) => {
  if (pct >= 95) return 'error'
  if (pct >= 75) return 'warning'
  return 'primary'
}

export const StorageUsage = ({ byteSize, bottom, fadeSx }) => {
  const navigate = useNavigate()
  const pct = Math.min(100, (byteSize / FREE_CREDIT_BYTES) * 100)

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom,
        left: 0,
        right: 0,
        px: 2,
        ...fadeSx,
      }}
    >
      <Typography
        variant="caption"
        onClick={() => navigate('/account#storage')}
        sx={{
          color: 'text.secondary',
          display: 'block',
          textAlign: 'center',
          fontWeight: 600,
          fontSize: '0.65rem',
          letterSpacing: '0.05em',
          cursor: 'pointer',
          mb: 0.5,
          '&:hover': { color: 'text.primary' },
        }}
      >
        STORAGE USAGE
      </Typography>
      <LinearProgress
        variant="determinate"
        value={pct}
        color={getProgressColor(pct)}
        sx={{ borderRadius: 1 }}
      />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', textAlign: 'center', mt: 0.5 }}
      >
        {Math.round((byteSize / FREE_CREDIT_BYTES) * 100)} %
      </Typography>
    </Box>
  )
}
